export default __webpack_public_path__ + "static/benchbottom-f368b6cb8473fecf37393478096ed5bb.png";